import { Box } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import ConsignmentInfo from '../ConsignmentInfo';
import { WaypointType } from '../types';
import ServiceWaypoint from './ServiceWaypoint';

interface ConsignmentServiceProps {
    expanded?: boolean;
    consignmentIndex: number;
    onChange?: () => void;
}

const ConsignmentService: React.FC<ConsignmentServiceProps> = ({ expanded = true, onChange, consignmentIndex }) => {
    const { formatMessage } = useIntl();
    const { watch } = useFormContext();

    const customerId = watch('customerId');
    const booking = watch(`bookings.${consignmentIndex}`);

    return (
        <>
            <ConsignmentInfo consignmentIndex={consignmentIndex} />
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'right',
                }}>
            </Box>

            <>

                <ServiceWaypoint consignmentIndex={consignmentIndex} waypointType={WaypointType.ShipFrom} customerId={customerId} />
                {booking.waypoints.map((waypoint: any, waypointIndex: number) => (
                    <ServiceWaypoint key={waypointIndex} consignmentIndex={consignmentIndex} waypointType={WaypointType.Waypoint} waypointId={waypointIndex} customerId={customerId} />
                ))}
                <ServiceWaypoint consignmentIndex={consignmentIndex} waypointType={WaypointType.DeliveryTo} customerId={customerId} />
            </>
        </>
    );
};

export default ConsignmentService;